export default (map, tier, beforeLayerId, visibility) => {
    tier.getStyle().layers.slice().reverse().forEach((layer) => {
        map.__om.style.addLayer(layer, beforeLayerId ? beforeLayerId : undefined, {
            validate: false
        });
        if (visibility === 'none') {
            map.setLayoutProperty(layer.id, 'visibility', visibility, { validate: false });
        }
        beforeLayerId = layer.id;
    });
    map.__om._update(true);
};



// WEBPACK FOOTER //
// ./map/tier/styleUpdate/updateTierVisibility.js